export default {
  club_name: 'Lørenskog Hockey',
  club_name_short: 'lorenskog',
  stadium_name: '',
  staging_url: 'https://lorenskog.api.fangroup.io',
  prod_url: 'https://lorenskog.api.fangroup.io',
  api: '/api',
  facebook: 'Lorenskogishockey',
  basename: '/lorenskog',
  club_logo: '/assets/teams/lorenskog.png',
  app_name: 'lorenskog',
  websale_name: 'lorenskog',
  ntb_team_id: 10040,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'lorenskog',
  monolithEnabled: false,
};
